import React from 'react';
export const Chip = ({ className }) => {
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", "data-testid": "data-source-clip" },
        React.createElement("g", { clipPath: "url(#clip0_3499_32466)" },
            React.createElement("path", { d: "M12.1445 0.0527344C10.0424 0.881787 8.99135 1.29629 8.04297 1.82852C5.47815 3.26788 3.35967 5.38635 1.92031 7.95117C1.38808 8.89956 0.973584 9.95064 0.144531 12.0527V0.0527344H12.1445Z", className: "fill-ai-primary" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_3499_32466" },
                React.createElement("rect", { width: "12", height: "12", fill: "white", transform: "translate(0.144531 0.0527344)" })))));
};
